import { render, staticRenderFns } from "./login2.vue?vue&type=template&id=3429c1a1&scoped=true"
import script from "./login2.vue?vue&type=script&lang=js"
export * from "./login2.vue?vue&type=script&lang=js"
import style0 from "./login2.vue?vue&type=style&index=0&id=3429c1a1&prod&lang=scss"
import style1 from "./login2.vue?vue&type=style&index=1&id=3429c1a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3429c1a1",
  null
  
)

export default component.exports